import {getDomainName} from "../../utils/utils";
import { useNavigate } from 'react-router-dom';

import './UserConfirmed.css'
import { useTranslations } from "../../utils/hooks/useTranslation";

function UserConfirmed() {
    const domainName = getDomainName()
    const navigate = useNavigate()

    const { translate } = useTranslations()

    // When we'll implement aicOn registration through iusercloud as well, we'll need to redirect accordingly to aicon or thermesis.
    // For now we just need to redirect to thermesis, therefore hardcoded value

    const redirectUrl = 'https://thermesis.auth.myaic.eu/login'

    return (
        <div className="UserConfirmed page">
            <div className="UserConfirmed_container">
                    <h2 className="UserConfirmed_welcome_title">{`${translate("Success")}`}</h2>
                    <div className="UserConfirmed_success">{`${translate('Your')}  ${domainName} ${translate('account is activated')}`}</div>
                    <div className="UserConfirmed_success">{translate('Now you can ')}
                        <a
                            data-testid="logIn"
                            className="btn__light"
                            href={redirectUrl}
                        >{translate('log in')}</a>
                    </div>
            </div>
        </div>
    )
}

export default UserConfirmed;

